import { keyBy, mapValues } from 'lodash';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { useEffect, useState, useMemo } from 'react';

import agentsResource from 'src/actions/agent/agentsResource';
import { getIvrsWithLatestVersion } from 'src/presentation/components/pages/shared/helpers/ivrsHelper';
import Thread from 'src/models/Thread/Thread';
import threadsResource from 'src/actions/threads/threadsResource';
import { toDateTimeString } from 'src/presentation/components/pages/shared/utils/TimeUtils';
import useResource, { getConsolidatedState, STATUS_SUCCEEDED } from 'src/presentation/hooks/useResource';
import { CHAT_BRAND } from 'src/constants/branding';

const normalizeValues = values =>
  values.map(value => ({ ...value, channel: CHAT_BRAND.name, updatedAt: toDateTimeString(value.updatedAt) }));

export default () => {
  const dispatch = useDispatch();

  const [threads, setThreads] = useState<Thread[]>([]);

  const { errors, loadingState: threadsLoadingState, values: rawThreads } = useResource(threadsResource);
  const { values: agents, loadingState: agentsLoadingState } = useResource(agentsResource);

  useEffect(() => {
    if (threadsLoadingState === STATUS_SUCCEEDED) {
      setThreads(normalizeValues(getIvrsWithLatestVersion(rawThreads)));
    }
  }, [dispatch, rawThreads, threadsLoadingState, setThreads]);

  const usersMap = useMemo(() => mapValues(keyBy(agents, 'id')), [agents]);
  const loadingState = getConsolidatedState([threadsLoadingState, agentsLoadingState]);
  const items = useMemo(
    () =>
      threads.map(thread => ({
        ...thread,
        updatedByString: thread?.publishedBy
          ? usersMap[thread?.publishedBy]?.name
          : thread?.publishedBy
          ? 'Deleted User'
          : '',
        updatedAtString: thread.publishedAt ? moment.utc(thread.publishedAt).local().format('MM/DD/YYYY hh:mm A') : '',
      })),
    [threads, usersMap]
  );

  return {
    errors,
    items,
    loadingState,
    resetErrors: threadsResource.actions.resetErrors,
  };
};
